import './utils/debug'

import signup from './utils/signup';

signup.signupPopup();
